import React, { useMemo } from 'react';
import { Mafs, Point, Line, Text, Theme } from 'mafs';

export const DotPlot = ({ config, variables }) => {
    const rawData = variables['data'] || config.data || [];
    const data = rawData.map(Number).filter(Number.isFinite).sort((a,b) => a - b);

    const { dots, xMin, xMax, yMax } = useMemo(() => {
        const freq = {};
        let min = Infinity, max = -Infinity;
        data.forEach(v => {
            freq[v] = (freq[v] || 0) + 1;
            if (v < min) min = v;
            if (v > max) max = v;
        });

        const points = [];
        let maxStack = 0;
        Object.keys(freq).forEach(k => {
            const val = parseFloat(k);
            const count = freq[k];
            if (count > maxStack) maxStack = count;
            for (let i = 0; i < count; i++) points.push({ x: val, y: 1 + i * 0.8 });
        });

        return { dots: points, xMin: min, xMax: max, yMax: 1 + maxStack * 0.8 };
    }, [data]);

    if (data.length === 0) return <div>No valid data</div>;

    // Unique sorted values for X-axis labels
    const uniqueVals = [...new Set(data)];

    return (
        <Mafs viewBox={{ x: [xMin - 1, xMax + 1], y: [0, yMax + 1] }} pan={false} height={250}>
            <Line.Segment point1={[xMin - 1, 0.5]} point2={[xMax + 1, 0.5]} color="black" />
            {uniqueVals.map(val => (
                <Text key={`l-${val}`} x={val} y={0} size={14}>{val}</Text>
            ))}
            {dots.map((d, i) => <Point key={i} x={d.x} y={d.y} color={Theme.blue} />)}
        </Mafs>
    );
};